import React, { useEffect } from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import { useDispatch, useSelector } from 'react-redux';
import { getCmsData } from '../../../Redux/action/MasterAction';
import parse from 'html-react-parser'
import FeedbackForm from '../../FeedbackForm/FeedbackForm';

const TermsAndCondition = () => {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getCmsData());
    }, [])

    const {
        loadingCmsDataListApi,
        CmsDataListApiData,
        CmsDataListApiError
    } = useSelector(state => state?.MasterReducer);

    return (
        <div>
            <Header />
            <FeedbackForm />
            <section className="blogs">
                <div className="container">
                    <div className="content" style={{ transform: "none", minHeight: 24, zIndex: "99", position: 'relative' }}>
                        <div className="container-fluid home-slide-text-new " style={{ transform: "none" }}>
                            <h1 className='text-center'>Terms And Conditions</h1>
                            {CmsDataListApiData?.[2]?.description ? parse(CmsDataListApiData?.[2]?.description) : ''}
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default TermsAndCondition